import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

let state = {
  popupType: null,
  popupResolve: null,
  popupReject: null,
  popupData: null,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
